import { render, staticRenderFns } from "./data-list-checkbox.vue?vue&type=template&id=3c5281c8&"
import script from "./data-list-checkbox.vue?vue&type=script&lang=js&"
export * from "./data-list-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports